import { LIST_ENTEIES } from "@/constants/default";
import { useTranslation } from "react-i18next";
import './style.css';

interface LimitProps {
    list?: number[]
    limit: number
    onChange: (s: number) => void
}

const LimitPaginationComponent = (props: LimitProps) => {
    const {t} = useTranslation()

    return (
        <div className="flex flex-row items-center me-5 min-w-[180px] w-[180px]">
            <label className="font-medium text-sm">
                <select
                    defaultValue={props.limit}
                    className="datatable-selector me-3"
                    onChange={e => props.onChange(parseInt(e.target.value))}
                >
                    {
                        (props?.list || LIST_ENTEIES).map(item => (<option key={item} value={item}>{item === 0 ? 'All' : item}</option>))
                    }
                </select>
                <span>{t("table.entries")}</span>
            </label>
        </div>
    )
}

export default LimitPaginationComponent;